import { render, staticRenderFns } from "./SendSettingsButton.vue?vue&type=template&id=0cd37f49&scoped=true&"
import script from "./SendSettingsButton.vue?vue&type=script&lang=js&"
export * from "./SendSettingsButton.vue?vue&type=script&lang=js&"
import style0 from "./SendSettingsButton.vue?vue&type=style&index=0&id=0cd37f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd37f49",
  null
  
)

export default component.exports